import http from '../jslibs/axios/http';

//订单管理 获取订单列表
export const orderlist = data => (http.get('/v1/cms/Order', data));

//订单管理 修改订单状态
export const changeorder = (data, uuid) => (http.put(`/v1/cms/Order/${uuid}`, data));

//订单管理 删除订单
export const delOrders = (uuid) => (http.delete(`/v1/cms/Order/${uuid}`));

//撤回订单
export const recallOrders = (data, uuid) => (http.put(`/v1/cms/OrderRecall/${uuid}`, data));
//订单管理 查看自动派单时间
export const dispatchTime = () => (http.get('/v1/cms/DispatchTime'));

//订单管理 查看自动派单时间
export const putDispatchTime = (data, id) => (http.put(`/v1/cms/DispatchTime/${id}`, data));

//订单管理 查看订单跟进记录
export const orderFollowRecord = (data, uuid) => (http.get(`/v1/cms/OrderFollowRecord/${uuid}`, data));

//订单管理 获取订单详情
export const orderDetail = uuid => (http.get(`/v1/cms/Order/${uuid}`));

//订单管理 新建订单
export const newOrder = data => (http.post('/v1/cms/Order', data));

//订单管理 导出订单
export const exportOrder = data => (http.get('/v1/cms/OrderCvs', data));

//订单管理 添加记录
export const addRecord = (data, uuid) => (http.put(`/v1/cms/OrderFollowRecord/${uuid}`, data));